// Lesson progress for the preview's top bar. The ref reflects the real block
// position in the lesson (current index / total blocks); MobilePreviewFrame
// provides it, PreviewShell consumes it. Default = a static 1-of-5 placeholder
// (e.g. Storybook / harness with no real lesson context).
import { createContext, useContext } from 'react'

export interface LessonProgress {
  total: number
  current: number
  /** Холст редактора: нижняя кнопка экрана листает урок дальше (выбирает
   *  следующий блок), чтобы автор прошёл урок прямо на холсте. Прохождение в
   *  предпросмотре задаёт свою кнопку через `run` и это поле не читает. */
  onNext?: () => void
  /** Шаг к предыдущему экрану — кнопка «назад» слева от нижней CTA, как в
   *  плеере. Нет (первый экран, миниатюры) — кнопки нет. */
  onBack?: () => void
}

export const LessonProgressContext = createContext<LessonProgress>({ total: 5, current: 1 })

export const useLessonProgress = () => useContext(LessonProgressContext)
